import { Button, ButtonGroup, Content, Dialog, Divider, Flex, Heading, Text, View } from '@adobe/react-spectrum';
import React from 'react';

import { BulletList } from '@exchange-frontends/components';

import { useStore } from '../../../store';

/**
 * @param {Object} props
 * @param {() => void} props.close
 * @param {() => void} props.onAccept
 */
const AdditionalPurchaseRequiredDialog = (props) => {
  const { close, onAccept } = props;
  const { purchaseDescription, pricePointDetail } = useStore((state) => state.detailScreen.pricingInfo);

  return (
    <Dialog>
      <Heading>Additional purchase required</Heading>
      <Divider />
      <Content>
        <Flex direction="column" gap="size-200">
          {purchaseDescription && <Text>{purchaseDescription}</Text>}
          {pricePointDetail?.length > 0 && (
            <View paddingTop="size-150">
              <strong>Price point detail:</strong>
              <View paddingTop="size-100">
                <BulletList values={pricePointDetail} />
              </View>
            </View>
          )}
        </Flex>
      </Content>
      <ButtonGroup>
        <Button variant="secondary" onPress={close}>
          Cancel
        </Button>
        <Button variant="cta" onPress={onAccept}>
          Continue
        </Button>
      </ButtonGroup>
    </Dialog>
  );
};

export default AdditionalPurchaseRequiredDialog;
